module.exports = __webpack_public_path__ + "img/service-contracts.d7bcf62b.svg";